var React = require('react');

function XInlineInline (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#fff;}.cls-2{fill:#909292;}")),React.createElement("rect",{"className":"cls-2","x":"2.5","y":"2.5","width":"300","height":"300","rx":"15.45","ry":"15.45","key":1}),React.createElement("path",{"className":"cls-1","d":"M167.42,140.23l58.38-67.87h-13.84l-50.7,58.93-40.49-58.93h-46.7l61.23,89.11-61.23,71.17h13.84l53.54-62.23,42.76,62.23h46.7l-63.5-92.41h0ZM148.47,162.26l-6.2-8.87-49.36-70.61h21.25l39.84,56.98,6.2,8.87,51.78,74.07h-21.25l-42.26-60.44h0Z","key":2})]);
}

XInlineInline.defaultProps = {"width":"26","height":"23","id":"Layer_1","viewBox":"0 0 305 305"};

module.exports = XInlineInline;

XInlineInline.default = XInlineInline;
